import { render, staticRenderFns } from "./GoodsCategoryModal.vue?vue&type=template&id=feb8aade&scoped=true"
import script from "./GoodsCategoryModal.vue?vue&type=script&lang=js"
export * from "./GoodsCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb8aade",
  null
  
)

export default component.exports